export const environment = {
    production: false,
    apiPlataforma: 'https://productoresdev.argbroker.com.ar/',
    //apiPlataforma: 'https://productores.argbroker.com.ar',
    apiCoverit: 'https://dev.cover-it.com.ar/api'
};
